import React from 'react';
import type { Summary } from '|/app/services';
import useNewCar from '|/hooks/use-new-car';
import type { SlotPreference } from '|/hooks/use-slot-preference/use-slot-preference';
import styles from './checkout-summary.module.css';

interface ScheduleCheckoutSummaryProps {
  summary: Summary | null;
  slotPreference: SlotPreference | undefined;
}

const ScheduleCheckoutSummary: React.FC<ScheduleCheckoutSummaryProps> = ({
  summary,
  slotPreference
}) => {
  const { getDealershipDisplayName } = useNewCar();

  if (!slotPreference) return null;

  const isPickup = summary?.transfer?.deliveryType?.toLowerCase() === 'pickup';
  const address = summary?.transfer?.address;
  const isVendingMachine = summary?.transfer?.locationType?.toLowerCase() === 'vendingmachine';
  const isNewCarDealership = summary?.vehicle?.vehicleType?.toLowerCase() === 'new';
  const city = address?.city ?? '';
  const { displayDate, displayTime, displayEndRange } = slotPreference;

  const locationName = isPickup
    ? isVendingMachine
      ? `${city} Vending Machine`
      : isNewCarDealership
        ? getDealershipDisplayName(city, city)
        : `${city} pickup location`
    : null;

  const heading = isPickup
    ? `Pickup ${displayDate} at ${displayTime} from`
    : `Delivery ${displayDate}`;

  const timeRange =
    !isPickup && displayTime && displayEndRange
      ? `Between ${displayTime} and ${displayEndRange}`
      : null;

  return (
    <div className={styles.container}>
      <p className={styles.heading}>
        {heading}
        {timeRange && (
          <>
            <br />
            {timeRange}
          </>
        )}
      </p>
      {locationName && <p className={styles.detail}>{locationName}</p>}
      {address && (
        <p className={styles.detail}>
          {address.line1}
          {address.line2 ? (
            <>
              <br />
              {address.line2}
            </>
          ) : null}
          <br />
          {address.city}, {address.state} {address.zipCode}
        </p>
      )}
    </div>
  );
};

export default ScheduleCheckoutSummary;
